import React from 'react';
import { Card, CardContent, Grid, GridColumn, Icon, Separator, Text } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';

const MeluAdditionalOffersCard = (): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;

  return (
    <Card type="light" background="neutral-bg-level-1">
      <CardContent>
        <Text>
          <p className="text-bold">{translate('meluCalculator.additionalOffers.title')}</p>
          <Separator spacing={'small'} />
          <Grid align={['middle-xs']}>
            <GridColumn width={['md-6']}>
              <Grid noWrap={true} align={['middle-xs']}>
                <GridColumn width={['min']}>
                  <Icon modifiers="#eu" size="md" />
                </GridColumn>
                <GridColumn width={['max']}>
                  <p className="text-small">{translate('meluCalculator.additionalOffers.callMinutes.text')}</p>
                </GridColumn>
              </Grid>
            </GridColumn>
            <GridColumn width={['md-6']}>
              <Grid noWrap={true} align={['middle-xs']}>
                <GridColumn width={['min']}>
                  <Icon modifiers="#5g" size="md" />
                </GridColumn>
                <GridColumn width={['max']}>
                  <p className="text-small">{translate('meluCalculator.additionalOffers.5g.text')}</p>
                </GridColumn>
              </Grid>
            </GridColumn>
          </Grid>
        </Text>
      </CardContent>
    </Card>
  );
};

export default observer(MeluAdditionalOffersCard);
